import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import { selectActiveFertilizerProducts } from 'scenes/Fertilizer/scenes/Products/components/FertilizerProductsVirtualizedTable/selectors';
import formatDropdownOptions from 'utils/format-dropdown-options';

const selectFertilizerProductsOptions = createDeepEqualSelector(
    selectActiveFertilizerProducts,
    (activeProductsArray) =>
        formatDropdownOptions(activeProductsArray, {
            keyField: 'id',
            textField: 'name'
        })
);

export { selectFertilizerProductsOptions };
